import { makeStyles } from '../../../../../styles';
export const useStyles = makeStyles((theme) => ({
    root: {
        '&.MuiTableRow-selected': {
            backgroundColor: theme.colors.gray[0],
        },
        '&.MuiTableRow-hover': {
            '&:hover': {
                backgroundColor: theme.colors.gray[0],
            },
        },
    },
}));
//# sourceMappingURL=TableRow.styles.js.map